import axios from "axios";
import Config from "@/config"

export default class MailService {
  support(accesstoken, data) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("email") + "/support", data,
        options
      )
      .then(res => res.data);
  }
}
